import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import EndeavorPlayerComponent from './js/endeavor-player.component';
import EndeavorPlayer from './js/components/endeavor-player';

ComponentsFactory.getInstance().define('endeavor-player', EndeavorPlayerComponent);

export {
    EndeavorPlayer
};
